import { isError, isLoading } from 'reference-resolvers-lite/Status';
import { getPropertyResolver } from 'reference-resolvers-lite/utils/getPropertyResolver';
import { createStandardCachedResolver } from 'reference-resolvers-lite/utils/createStandardCachedResolver';
import { useFetchResolver } from 'reference-resolvers-lite/ResolverHooks';
import { SkeletonText } from 'reference-resolvers-lite/components/SkeletonText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AvatarCell } from '../AvatarCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const InnerAvatarContent = ({
  id,
  email,
  name
}) => {
  if (!id) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "datatable.userCell.unassigned"
    });
  }
  if (!email) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: String(name)
    });
  }
  const result = `${name} (${email})`;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: result
  });
};
const SuccessContent = ({
  reference,
  id
}) => {
  const label = reference.label;
  const description = reference.description;
  return /*#__PURE__*/_jsx(AvatarCell, {
    type: "hubSpotUserEmail",
    id: description,
    displayName: label,
    children: /*#__PURE__*/_jsx(InnerAvatarContent, {
      id: id,
      name: reference.label,
      email: reference.description
    })
  });
};

// to be kept aligned with these:
// https://git.hubteam.com/HubSpot/customer-data-properties/blob/master/customer-data-properties/static/js/v2/shims/PropertyInputExternalOptionShim.tsx#L76
const getPlaceholder = type => {
  switch (type) {
    case 'USER':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "datatable.userCell.noUser"
      });
    case 'OWNER':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "datatable.userCell.noOwner"
      });
    default:
      {
        const exhaustiveCheck = type;
        throw new Error(`unhandled type ${exhaustiveCheck}`);
      }
  }
};
export const ResolvedUserCell = ({
  id,
  type,
  objectTypeId,
  propertyDefinition
}) => {
  const resolver = propertyDefinition && getPropertyResolver({
    property: propertyDefinition,
    objectTypeId
  }) || createStandardCachedResolver(type, objectTypeId);
  const parsedId = id === undefined || id === null || id === '' ? undefined : id;
  const {
    status,
    reference
  } = useFetchResolver(resolver, parsedId);
  if (isLoading(status)) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      "data-test-id": "loading-text"
    });
  }
  if (isError(status)) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: id
    });
  }
  if (reference === undefined || parsedId === undefined) {
    return getPlaceholder(type);
  }
  return /*#__PURE__*/_jsx(SuccessContent, {
    reference: reference,
    id: parsedId
  });
};
export default ResolvedUserCell;